<div class="grouped-checkbox-filter">
  <div class="grouped-checkbox-filter__search">
    <input type="text" [(ngModel)]="searchString" (ngModelChange)="searchStringChanged()" #inputEl placeholder="Suche nach Anforderungen z.B. Logisches Denken">
    <div class="grouped-checkbox-filter__search-icon"><brt-icon [icon]="'search'"></brt-icon></div>
    <button role="button" class="grouped-checkbox-filter__clear-icon" (click)="clearInput()" [disabled]="searchString.length === 0"><brt-icon [icon]="'x-reg-circle'"></brt-icon></button>
    <div class="grouped-checkbox-filter__search-outline"></div>
  </div>

  <div class="grouped-checkbox-filter__groups">
    <div class="grouped-checkbox-filter__group" *ngFor="let group of groups; index as idx; trackBy: groupTracker">
      <div class="grouped-checkbox-filter__group-title">
        {{group.title}}
        <div class="grouped-checkbox-filter__group-title-page">{{addLeadingZero(idx + 1)}} / {{addLeadingZero(groups.length)}}</div>
      </div>

      <div class="grouped-checkbox-filter__group-options">
        <ng-container *ngIf="isAnyVisibleInGroup(group); else nothingFoundMessage;">
          <ng-container *ngFor="let option of group.options; trackBy: optionTracker">
            <div class="grouped-checkbox-filter__group-option" [ngClass]="{'hidden': !option.visible}">
              <brt-icon-checkbox (state-changed)="toggleOption(option.id)"
                                 [data]="{id: option.id, title: option.label, selected: option.selected, icon: getIconById(option.id), hint: option.tooltip}"></brt-icon-checkbox>
            </div>
          </ng-container>
        </ng-container>

        <ng-template #nothingFoundMessage>
          <div class="grouped-checkbox-filter__group-empty-message">Keine Einträge gefunden</div>
        </ng-template>

      </div>


    </div>
  </div>
</div>
